import createIcon from '../../createIcon';

/**
 * @component @name EmojiFoodBeverage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g4VjUuNEw5LjgxIDYuODVDOS45MyA2Ljk0IDEwIDcuMDkgMTAgNy4yNFYxMS41QzEwIDExLjc4IDkuNzggMTIgOS41IDEySDUuNUM1LjIyIDEyIDUgMTEuNzggNSAxMS41VjcuMjRDNSA3LjA5IDUuMDcgNi45NCA1LjE5IDYuODVMNyA1LjRWM0gzVjEzQzMgMTUuMjEgNC43OSAxNyA3IDE3SDEzQzE1LjIxIDE3IDE3IDE1LjIxIDE3IDEzVjEwSDE5QzIwLjExIDEwIDIxIDkuMSAyMSA4VjVDMjEgMy44OSAyMC4xMSAzIDE5IDNaTTE5IDhIMTdWNUgxOVY4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDE5SDNWMjFIMTlWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmojiFoodBeverage = createIcon('EmojiFoodBeverage', [
  [
    'path',
    {
      d: 'M19 3H8V5.4L9.81 6.85C9.93 6.94 10 7.09 10 7.24V11.5C10 11.78 9.78 12 9.5 12H5.5C5.22 12 5 11.78 5 11.5V7.24C5 7.09 5.07 6.94 5.19 6.85L7 5.4V3H3V13C3 15.21 4.79 17 7 17H13C15.21 17 17 15.21 17 13V10H19C20.11 10 21 9.1 21 8V5C21 3.89 20.11 3 19 3ZM19 8H17V5H19V8Z',
      key: '1e9nnk',
    },
  ],
  ['path', { d: 'M19 19H3V21H19V19Z', key: '1omijy' }],
]);

export default EmojiFoodBeverage;
